// CommonJS on purpose: consumed by both the CRA bundle
// (src/components/SeoStructuredData.js) and the plain Node post-build script
// (scripts/generate-route-html.js).
const routeMeta = require('./route-meta');

const { ROUTE_META } = routeMeta;

const SITE_URL = 'https://www.inloop.tech';
const ORGANIZATION_ID = `${SITE_URL}/#organization`;

const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': ORGANIZATION_ID,
  name: 'inLoop',
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/logo512.png`,
  description: 'AI-powered behavioral loyalty SaaS by the adesso Group.',
  parentOrganization: {
    '@type': 'Organization',
    name: 'adesso Group',
    url: 'https://www.adesso-group.de/',
  },
};

// Short display names for breadcrumbs — ROUTE_META titles are full SEO titles.
const BREADCRUMB_NAMES = {
  '/product-features': 'Product & Features',
  '/further-capabilities': 'Further Capabilities',
  '/references': 'References',
  '/blog': 'Blog',
  '/faq': 'FAQ',
  '/about-us': 'About Us',
  '/contact-us': 'Contact Us',
  '/pricing': 'Pricing',
  '/ai-intelligence': 'inLoop AI Live',
};

const SOFTWARE_APPLICATION_ROUTES = ['/', '/product-features'];

const buildSoftwareApplicationSchema = (route) => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'inLoop',
  url: `${SITE_URL}${route === '/' ? '/' : route}`,
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  description: (ROUTE_META[route] || {}).description,
  publisher: { '@id': ORGANIZATION_ID },
});

const buildBreadcrumbSchema = (route) => {
  const name = BREADCRUMB_NAMES[route];
  if (!name) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
      { '@type': 'ListItem', position: 2, name, item: `${SITE_URL}${route}` },
    ],
  };
};

// Detail routes inherit their listing page's breadcrumb; the page component
// adds its own data-dependent schema (e.g. Article) on top.
const normalizeRoute = (pathname) => {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (normalized.startsWith('/blog/')) return '/blog';
  if (normalized.startsWith('/references/')) return '/references';
  return normalized;
};

const getRouteSchemas = (pathname) => {
  const route = normalizeRoute(pathname);
  const schemas = [ORGANIZATION_SCHEMA];

  if (SOFTWARE_APPLICATION_ROUTES.includes(route)) {
    schemas.push(buildSoftwareApplicationSchema(route));
  }

  if (route !== '/') {
    const breadcrumb = buildBreadcrumbSchema(route);
    if (breadcrumb) schemas.push(breadcrumb);
  }

  return schemas;
};

module.exports = {
  SITE_URL,
  ORGANIZATION_ID,
  getRouteSchemas,
};
